import {createPortal} from 'react-dom';

import Button from '@/shared/components/button';
import {localize} from '@/shared/services/i18n';

import {CookieConsentInitialProps} from '../types';
import CookieAgreement from './CookieAgreement';

function CookieConsentInitialNonBlocking({
  onCustomizeSettings,
  onAcceptAll,
}: CookieConsentInitialProps) {
  return createPortal(
    <section
      id="shBanner"
      data-test-id="cookie-consent-modal"
      className="fixed right-0 bottom-0 left-0 z-50 bg-white px-4 py-6 shadow-legal-footer sm:px-8"
    >
      <div className="flex flex-col gap-7 sm:flex-row">
        <CookieAgreement className="flex-1 sm:basis-7/12" />
        <div className="flex max-w-full flex-col gap-4 sm:w-fit sm:flex-row sm:flex-wrap sm:content-start">
          <Button
            onClick={onCustomizeSettings}
            variant="system"
            size="standard"
            className="h-11 text-lg sm:h-13 sm:grow"
          >
            {localize('cookie_consent_customize_settings')}
          </Button>
          <Button
            variant="system"
            onClick={onAcceptAll}
            size="standard"
            className="h-11 text-lg sm:h-13 sm:grow"
          >
            {localize('cookie_consent_accept_all')}
          </Button>
        </div>
      </div>
    </section>,
    document.body
  );
}

export default CookieConsentInitialNonBlocking;
